import React from 'react'
import { Breadcrumb } from 'shared/layout/CustomHead/Schemas/breadcrumbSchema'
import { ifHovered, Paragraph } from 'components/styles'
import { TextMods } from 'components/styles/primitives/modifiers/text/textMods'
import { BlockComponent } from 'lib'
import styled from '@emotion/styled'
import { ifBefore } from '../../styles/primitives/selectors/ifBefore'
import { List } from '../../layout/List'
import { css } from '@emotion/react'
import { SEOLink } from '../links/SEOLink'
import { colors } from 'parameters/ui'

interface Props {
	breadcrumbs: Array<Breadcrumb>
}

export const Breadcrumbs: BlockComponent<Props> = ({ breadcrumbs }) => {
	return (
		<nav aria-label="breadcrumb">
			<UnstyledList>
				<List Of={CrumbLink} entries={breadcrumbs} />
			</UnstyledList>
		</nav>
	)
}

const CrumbLink: React.FC<React.PropsWithChildren<Breadcrumb>> = ({ url, name }) => (
	<Paragraph as="li" small>
		<SEOLink AnchorComponent={Anchor} href={url}>
			{name}
		</SEOLink>
	</Paragraph>
)

//TODO: sort out why text style is unique or if others should also be darker. Determine global highlight for links
const Anchor = styled.a([
	TextMods({
		color: colors.primaryDarkGrey1,
		textDecoration: 'underline'
	}),
	ifHovered(css({ color: colors.primaryPurple1, textDecoration: 'none' }))
])

const UnstyledList = styled.ol`
	display: flex;

	//Used to skip the first element, since emotion joins styles by hash and nth-of-type isnt safe
	li + li {
		display: inline-block;
		${ifBefore(css`
			display: inline-block;
			margin: 0 0.25em;
			transform: rotate(15deg);
			border-right: 0.1em solid ${colors.secondaryLightGrey1};
			height: 0.8em;
			content: '';
			${ifHovered(css({ textDecoration: 'none' }))}
		`)}
	}

	list-style: none;
`
